import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";

import IndexLayout from "./layout/IndexLayout.js";
import AdminLayout from "./layout/AdminLayout.js";
import Test1 from "./pages/Test1.js";
import Test2 from "./pages/Test2.js";
import Test3 from "./pages/Test3.js";
import Index from "./pages/Index.js";
import About from "./pages/About.js";
import Industry from "./pages/Industry.js";
import Contact from "./pages/Contact.js";
import Company from "./pages/Company.js";
import Recomend from "./pages/Recomend.js";
import Article from "./pages/Article.js";
export default function Main() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<IndexLayout />}>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/industry" element={<Industry />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/company" element={<Company />} />
          <Route path="/recommend" element={<Recomend />} />
          <Route path="/article/:id" element={<Article />} />
        </Route>

        <Route path="/admin/" element={<AdminLayout />}>
          <Route path="expenses" element={<Test2 />} />
          <Route path="invoices" element={<Test3 />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
